<style scoped lang="scss" type="text/scss">

</style>

<template>
    <el-dialog
            :title="'正在' + (isUpdate ? '更新' : '添加') + '参赛机器人'"
            :close-on-click-modal="false"
            @closed="reset"
            :visible.sync="visibleSync"
            width="70%">
        <el-form :model="robotInfo" ref="form" :rules="rules" label-width="60px">
            <two-cols-row>
                <el-form-item label="名称" prop="name" slot="left">
                    <el-input v-model="robotInfo.name" placeholder="最多 15 字"></el-input>
                </el-form-item>
                <el-form-item label="重量" prop="weight" slot="right">
                    <el-input v-model="robotInfo.weight">
                        <template slot="append">kg</template>
                    </el-input>
                </el-form-item>
            </two-cols-row>

            <three-cols-row>
                <el-form-item label="长度" prop="length" slot="left">
                    <el-input v-model="robotInfo.length">
                        <template slot="append">mm</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="宽度" prop="width" slot="middle">
                    <el-input v-model="robotInfo.width">
                        <template slot="append">mm</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="高度" prop="height" slot="right">
                    <el-input v-model="robotInfo.height">
                        <template slot="append">mm</template>
                    </el-input>
                </el-form-item>
            </three-cols-row>

            <el-form-item label="介绍" prop="introduce">
                <el-input
                        class="full-width"
                        type="textarea"
                        :rows="8"
                        placeholder="机器人的特点、创新等，最多 120 字"
                        v-model="robotInfo.introduce">
                </el-input>
            </el-form-item>

            <el-form-item style="margin-bottom: 0;">
                <el-button type="primary" plain @click="confirm()" :loading="requesting">保存</el-button>
                <el-button @click="cancel()">取消</el-button>
                <el-button v-if="deletable" type="danger" style="float: right;" @click="remove()"
                           :loading="deleteRequesting">删除
                </el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
    import TwoColsRow from '../../../../../components/el-form-item-aux/two-cols-row/index';
    import ThreeColsRow from '../../../../../components/el-form-item-aux/three-cols-row/index';

    export default {
        name: '',
        components: {
            TwoColsRow,
            ThreeColsRow
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            isUpdate: {
                type: Boolean,
                default: false
            },
            deletable: {
                type: Boolean,
                default: false
            },
            id: {
                type: Number,
                default: null
            }
        },
        watch: {
            visible (visible) {
                this.visibleSync = visible;
                if (!visible) return;
                const id = this.id;
                if (id === null || id === undefined) {
                    this.robotInfo = {};
                } else {
                    this.$store.dispatch('player/loadRobotInfo', {
                        id
                    }).then(response => {
                        this.robotInfo = response.data;
                    });
                }
            },
            visibleSync (visibleSync) {
                this.$emit('update:visible', visibleSync);
            }
        },
        data () {
            const checkLength = async (rule, value, callback) => {
                if (isNaN(+value)) {
                    callback(new Error('长宽高只能是数字'));
                }
                if (+value < 0) {
                    callback(new Error('长宽高不能小于 0'));
                }
                if (+value > 10000) {
                    callback(new Error('长宽高不能超过 10,000 mm'));
                }
            };
            const checkWeight = async (rule, value, callback) => {
                if (isNaN(+value)) {
                    callback(new Error('重量只能是数字'));
                }
                if (+value < 0) {
                    callback(new Error('重量不能小于 0'));
                }
                if (+value > 10000) {
                    callback(new Error('重量不能超过 10,000 kg'));
                }
            };
            return {
                visibleSync: null,
                robotInfo: {},
                requesting: false,
                deleteRequesting: false,
                rules: {
                    name: [
                        {required: true, message: '机器人名称不能为空', trigger: 'blur'},
                        {min: 1, max: 15, message: '长度不能超过 15 个字', trigger: 'blur'}
                    ],
                    length: [
                        {required: true, message: '长度不能为空', trigger: 'blur'},
                        {validator: checkLength, trigger: 'blur'}
                    ],
                    width: [
                        {required: true, message: '宽度不能为空', trigger: 'blur'},
                        {validator: checkLength, trigger: 'blur'}
                    ],
                    height: [
                        {required: true, message: '高度不能为空', trigger: 'blur'},
                        {validator: checkLength, trigger: 'blur'}
                    ],
                    weight: [
                        {required: true, message: '重量不能为空', trigger: 'blur'},
                        {validator: checkWeight, trigger: 'blur'}
                    ],
                    introduce: [
                        {required: true, message: '介绍不能为空', trigger: 'blur'},
                        {min: 1, max: 120, message: '介绍不能超过 120 字', trigger: 'blur'}
                    ]
                }
            };
        },
        computed: {
            currentManagedPlayerId () {
                return this.$store.state.player.currentManagedPlayerId;
            }
        },
        methods: {
            remove () {
                this.$deleteConfirm().then(_ => {
                    this.$normalRequest('player/deleteRobot', {id: this.id}, '删除成功', true, this, 'deleteRequesting').then(_ => {
                        this.$emit('need-reload');
                        this.reset();
                    }).catch(_ => {
                    });
                }).catch(_ => {
                });
            },
            confirm () {
                if (this.isUpdate) {
                    this.update();
                } else {
                    this.create();
                }
            },
            create () {
                this.handleTemplate('player/createRobot', '创建成功');
            },
            update () {
                this.handleTemplate('player/updateRobot', '更新成功');
            },
            handleTemplate (actionName, tip) {
                this.$refs.form.validate((valid) => {
                    if (!valid) return false;
                    const robotInfo = this.robotInfo;
                    robotInfo.length = +robotInfo.length;
                    robotInfo.width = +robotInfo.width;
                    robotInfo.height = +robotInfo.height;
                    robotInfo.weight = +robotInfo.weight;
                    this.$normalRequest(actionName, {
                        id: this.currentManagedPlayerId,
                        ...robotInfo
                    }, tip, true, this, 'requesting').then(_ => {
                        this.afterSuccess();
                    }).catch(_ => {
                    });
                });
            },
            cancel () {
                this.reset();
            },
            afterSuccess () {
                this.$emit('need-reload');
                this.reset();
            },
            reset () {
                this.$refs.form.clearValidate();
                this.$refs.form.resetFields();
                this.visibleSync = false;
                this.robotInfo = {};
            }
        }
    };
</script>
